import { AuthError, resendSignUpCode, signIn } from "aws-amplify/auth";
import { paths } from "config/paths";
import { useFormik } from "formik";
import { useWebRouter } from "~utils/next-router/use-web-router";
import {
	SignInV2FormValues,
	SignInV2Schema,
	toast,
	SignInV2 as View,
} from "ui-components";
import { useAuthContext } from "~auth/contexts/auth";

export const SignInV2 = () => {
	const router = useWebRouter();
	const { refreshSession } = useAuthContext();
	const form = useFormik<SignInV2FormValues>({
		validateOnMount: true,
		initialValues: {
			email: "",
			password: "",
		},
		validationSchema: SignInV2Schema,
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					const signInRes = await signIn({
						username: values.email,
						password: values.password,
					});

					if (signInRes.nextStep.signInStep === "CONFIRM_SIGN_UP") {
						toast.error("Email verification needed!");
						await resendSignUpCode({ username: values.email });
						void router.push(paths.signUpVerificationV2(values.email));
						return;
					}
					if (signInRes.nextStep.signInStep === "DONE") {
						toast.success("Redirecting you to portal...");
						await refreshSession();
						return;
					}

					throw new Error("Something went wrong!");
				},
				{
					loading: "Signing you in...",
					error: (e) => {
						helpers.setSubmitting(false);
						if (e instanceof AuthError) return e.message;
						return "Something went wrong!";
					},
				},
			);
		},
	});

	return <View form={form} />;
};
